export default {
  // 查询保证金列表
  selectYxUserDepositByList: '/ygsjzs/yxUserDeposit/selectYxUserDepositByList',
  // 查询保证金详情
  selectYxUserDepositByDepositId: '/ygsjzs/yxUserDeposit/selectYxUserDepositByDepositId',
  // 查询保证金流水列表
  selectYxDepositTransactionByList: '/ygsjzs/yxUserDeposit/selectYxDepositTransactionByList',
  // 导出
  // exportYxDepositTransaction: '/ygsjzs/yxUserDeposit/exportYxDepositTransaction',
  selectYxDepositGoodsByList: '/ygsjzs/yxUserDeposit/selectYxDepositGoodsByList',
  exportYxDepositGoods: '/ygsjzs/yxUserDeposit/exportYxDepositGoods',
  // 详情的流水导出
  exportYxDepositTransaction: '/ygsjzs/yxTransNew/exportYxDepositTransaction',

  // 收益保证金调整
  insertYxUserDepositRecord: '/ygsjzs/yxUserDeposit/insertYxUserDepositRecord',
  // 流水列表
  selectYxTransNewByPage: '/ygsjzs/yxTransNew/selectYxTransNewByPage'
}
